import React, { useEffect, useState } from "react";
import Breadcrumbs from '../../components/Common/Breadcrumb';
import { Label,Input,Modal,ModalHeader,Button,Col,Row } from "reactstrap";
import Table from 'react-bootstrap/Table';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import Form from 'react-bootstrap/Form';
import 'bootstrap/dist/css/bootstrap.min.css';
import {ToastContainer,toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import FloatingLabel from 'react-bootstrap/FloatingLabel';


export default function Stores() {
    const[email,setEmail] = useState('');
    const[company,setCompany]=useState('');
    const[stores, setStores] = useState([]);
    const[selectedStore, setSelectedstore] = useState('')
    const[search, setSearch] = useState('');
    const[modal, setModal] = useState(false);
    const[modal2, setModal2] = useState(false);
    const[storeid, setStoreid] = useState('');
    const[storename, setStorename] = useState('');
    const[storeemail,setStoremail] = useState('');
    const[location, setLocation] = useState('');
    const[storePhone, setStorephone] = useState('')
    const[searchText, setSearchtext] = useState('Search')
    const[err,setErr] = useState('')
    const[submitText, setSubmittext] = useState('Submit')
    const[detachText, setDetachtext] = useState('Detach store');

     const[phone, setPhone] = useState('')
     const[registration, setRegistration] = useState('')
     const [formattedCoordinates, setFormattedCoordinates] = useState("");
     const [searchQuery, setSearchQuery] = useState("");
     const [suggestions, setSuggestions] = useState([]);
     const [selectedLocation, setSelectedLocation] = useState(null);


       // Fetch suggestions
  const fetchSuggestions = async (query) => {
    if (!query) {
      setSuggestions([]);
      return;
    }
    const response = await fetch(
      `https://nominatim.openstreetmap.org/search?q=${query}&format=json&addressdetails=1&limit=5`
    );
    const data = await response.json();
    setSuggestions(data);
  };

  const handleSuggestionClick = (suggestion) => {
    const location = {
      lat: parseFloat(suggestion.lat),
      lng: parseFloat(suggestion.lon),
    };

    // Format coordinates as 0000,0000
    const formatted = `${location.lat.toFixed(4)},${location.lng.toFixed(4)}`;
    // const calculatedDistance = calculateDistance(location, predefinedLocationB).toFixed(2); // Calculate distance

    setSearchQuery(suggestion.display_name); // Update the input field
    setSelectedLocation(location);
    setFormattedCoordinates(formatted); // Update formatted coordinates
    // setDistance(`${calculatedDistance}`); // Update the distance state
    setSuggestions([]); // Clear suggestions
  };


    useEffect(() => {
            const fetchProfile = async () => {
              try {
                const res = await fetch('https://easyboxadminapi.uuidesign.xyz/api/profile', {
                  credentials: 'include', // to send cookies
                });
                const data = await res.json();
        
                if (data.valid) {
                  setEmail(data.email)
                } else {}
              } catch (error) {} 
            };
        
            fetchProfile();
          }, []);
        
          //get store id
          useEffect(()=>{
           const fetchData = async()=>{
              try{
                const res = await fetch(`https://easyboxadminapi.uuidesign.xyz/api/getUserdetails?email=${email}`);
                const data = await res.json();
                setCompany(data.company)
              }
              catch(err){}
           }
        
           if(email){
            fetchData();
           }
           
          },[email]);


    useEffect(()=>{
        const getStores =async()=>{
            const res = await fetch(`https://easyboxadminapi.uuidesign.xyz/api/getMystores?company=${company}`);
            const data = await res.json();
            setStores(data)
        }

        if(company){
            getStores();
        }

    },[company])

    const getStores =async()=>{
            const res = await fetch(`https://easyboxadminapi.uuidesign.xyz/api/getMystores?company=${company}`);
            const data = await res.json();
            setStores(data)
        }

      const exportToPdf = () => {
        const doc = new jsPDF();
    
        // Add a title to the PDF
        doc.text("Easybox_stores", 20, 10);
    
        // Extract table headers and rows from the DOM
        const table = document.getElementById("dataTable");
        const headers = Array.from(
          table.querySelectorAll("thead tr th")
        ).map((header) => header.textContent);
    
        const rows = Array.from(table.querySelectorAll("tbody tr")).map((row) =>
          Array.from(row.querySelectorAll("td")).map((cell) => cell.textContent)
        );
    
        // Generate the PDF table
        doc.autoTable({
          head: [headers],
          body: rows,
          startY: 20,
        });
    
        // Save the PDF
        doc.save("Easybox_stores.pdf");
    }

    const getThisstore =async()=>{
        setSearchtext('Please wait...')
        const res = await fetch(`https://easyboxadminapi.uuidesign.xyz/api/searchStore?storeid=${storeid}`);
        const data = await res.json();
        if(data.success == true){
            setStorename(data.store_name);
            setStoremail(data.email);
            setStorephone(data.phone);
            setLocation(data.location);
            setSearchtext('Search')
            setErr('')

        }
        else{
            setErr('No store found')
            setSearchtext('Search')
        }
       
    }

    const toggle2 =async(e)=>{
        const id = e.target.value;
        setStoreid(id);
        const res = await fetch(`https://easyboxadminapi.uuidesign.xyz/api/searchStore?storeid=${id}`);
        const data = await res.json();
        setStorename(data.store_name);
        setStoremail(data.email);
        setStorephone(data.phone);
        setLocation(data.location);
        setModal2(!modal2)
    
    }

    const toggle =()=>{
        setModal(!modal)
    }

    const createStore =async()=>{
        const characters = 'ABCDEFGHIJKLMNOoppPQRSTUVWXYZ0123456789'; 
        let result = '';
        
        // Generate a random 8-character string
        for (let i = 0; i < 5; i++) {
        const randomIndex = Math.floor(Math.random() * characters.length);
        result += characters[randomIndex]; 
        }
        const branchID = `RDSB-${result}`;

        if(storename,phone,storeemail,registration){
            setSubmittext('Please wait...')
            const res = await fetch('https://easyboxadminapi.uuidesign.xyz/api/createStore',{
                method:"POST",
                headers:{
                    "Content-Type":"application/json"
                },
                body:JSON.stringify({storename,phone,email:storeemail,password:'123456',formattedCoordinates,searchQuery,registration,branchID}),
                credentials:"include"
            })

            const data = await res.json();
            const {success} = data;
            if(success){
                toast.success("Store created");
                setStorename('');
                setRegistration('');
                setPhone('')
                setEmail('')
                setSearchQuery('')
                setFormattedCoordinates('');
                getStores()
                setSubmittext('SIGN UP')
                setModal(false)
            }
            else{
                toast.error('Something went wrong!')
                setSubmittext('SIGN UP')
            }
        }
     }


    const detachStore =async()=>{
        setDetachtext('Please wait...');
        const res = await fetch(`https://easyboxadminapi.uuidesign.xyz/api/detachStore?store=${storeid}&company=${company}`);
        const data = await res.json();
        const{success} = data;
        if(success == true){
            setDetachtext('Detach store')
            toast.success('Store has been detached. You will not be able to do deliveries for the store.')
            setStoreid('');
            setStorename('');
            setStorephone('');
            setStoremail('');
            setLocation('');
            getStores();
            setModal2(false)

        }
        else{
            setDetachtext('Detach store')
            toast.error('Something went wrong. Please try again!')
        }
        
    }
  return (
    <div className="pagesContainer">
    <ToastContainer />
        <Breadcrumbs title="Easybox" breadcrumbItem="Stores" />
        <div className="card" style={{padding:'10px'}}>
        <div className="searchBar">
            <div className="mb-4" id="mb">
                <Label className="form-label">Search order</Label>
                <Input
                    name="search"
                    className="form-control"
                    placeholder="Search order"
                    type="text"
                    onChange={(e)=>{setSearch(e.target.value)}}
                    value={search}

                />
                
            </div>

        </div>
        <div className="">
        <Button color='info' onClick={toggle}>+ Add store</Button>
        <Button color='success' onClick={exportToPdf} style={{marginLeft:'2%'}}>Export</Button>
        </div>
        <hr />

        <div className="table-responsive">
        <Table striped bordered hover id="dataTable">

            <thead>
                <tr>
                    
                    <th scope="col">#</th>
                    <th scope="col">Store id</th>
                    <th scope="col">Name</th>
                    <th scope="col">Email</th>
                    <th scope="col">Phone</th> 
                    <th scope="col">Location</th>  
                    <th scope="col">Status</th> 

                </tr>
            </thead>
            <tbody>
            {stores.map((val,index)=>{
                
                return(
                    <tr>
                        <td>{index+1}</td>
                        <td><button className="tableButton" value={val.store_id} onClick={toggle2}>{val.store_id}</button></td>
                        <td>{val.store_name}</td>
                        <td>{val.email}</td>
                        <td>{val.phone}</td>
                        <td>{val.location}</td>
                        <td>{val.thisStatus}</td>
                    </tr>
                )
            })}
            </tbody>
            </Table>
        </div>
    </div>

    <Modal isOpen={modal} toggle={toggle} size='md'>
        <ModalHeader>Add store</ModalHeader>
        <div className="modalContainer">
        <div className="mb-4">
                        <Label className="form-label">Store name</Label>
                        <Input
                          name="email"
                          className="form-control"
                          placeholder="Store name"
                          type="text"
                          onChange={(e)=>{setStorename(e.target.value)}}
                          value={storename}

                        />
                        </div>
                        <div className="mb-4">
                        <Label className="form-label">Registration/ID</Label>
                        <Input
                          name="email"
                          className="form-control"
                          placeholder="Registration/ID"
                          type="text"
                          onChange={(e)=>{setRegistration(e.target.value)}}
                          value={registration}

                        />
                        </div>

                        <div className="mb-4">
                        <Label className="form-label">Email</Label>
                        <Input
                          name="email"
                          className="form-control"
                          placeholder="Enter email"
                          type="email"
                          onChange={(e)=>{setStoremail(e.target.value)}}
                          value={storeemail}

                        />
                        </div>
                        <div className="mb-4">
                        <Label className="form-label">Phone number</Label>
                        <Input
                          name="email"
                          className="form-control"
                          placeholder="Enter Phone number"
                          type="text"
                          onChange={(e)=>{setPhone(e.target.value)}}
                          value={phone}

                        />
                        </div>
                        <div style={{ position: "relative"}}>
                            <input
                            style={{width:'100%',height:'40px',border:'1px solid gray',borderRadius:'3px'}}
                            
                            type="text"
                            value={searchQuery}
                            onChange={(e) => {
                                setSearchQuery(e.target.value);
                                fetchSuggestions(e.target.value);
                            }}
                            placeholder="Store location location"
                            className='locationInput'
                            />
                        <div
                            style={{
                                position: "absolute",
                                top: "100%",
                                left: "0",
                                background: "white",
                                border: "1px solid #ddd",
                                zIndex: 1000,
                                width: "100%",
                                maxHeight: "150px",
                                overflowY: "auto",
                            }}
                        >
                        {suggestions.map((suggestion, index) => (
                            <div
                            key={index}
                            onClick={() => handleSuggestionClick(suggestion)}
                            style={{
                                cursor: "pointer",
                                padding: "10px",
                                borderBottom: "1px solid #ddd",
                            }}
                            >
                            {suggestion.display_name}
                            </div>
                        ))}
                    </div>
                    </div>
      
                      
                        
                       


                        <Row>
                          
                          <Col className="col-7">
                            {/* <div className="text-md-end mt-3 mt-md-0">
                              <Link
                                to="/auth-recoverpw"
                                className="text-muted"
                              >
                                <i className="mdi mdi-lock"></i> Forgot your
                                password?
                              </Link>
                            </div> */}
                          </Col>
                        </Row>
                        <div className="d-grid mt-4">
                          <button
                          style={{backgroundColor:'red',color:"white",fontWeight:"500"}}
                            className="btn waves-effect waves-light"
                            type="submit"
                            onClick={createStore}
                          >
                           {submitText}
                          </button>
                        </div>
                       
                        <div className="mt-4 text-center">
                 

                      
                    </div>
        </div>
    </Modal>

    <Modal isOpen={modal2} toggle={toggle2} size='md'>
        <ModalHeader>{storename}</ModalHeader>
        <div className="modalContainer">
            <FloatingLabel className='formInput' controlId="floatingInputGrid" label="Enter store id" >
                <Form.Control  className='inputSearch' value={storeid}  type="text" placeholder="Enter store id" disabled />
            </FloatingLabel>
            <FloatingLabel className='formInput' controlId="floatingInputGrid" label="Store name" >
                <Form.Control  className='inputSearch' value={storename}  type="text" placeholder="Store name" disabled />
            </FloatingLabel>
            <FloatingLabel className='formInput' controlId="floatingInputGrid" label="Email" >
                <Form.Control  className='inputSearch' value={storeemail}  type="text" placeholder="Email" disabled />
            </FloatingLabel>
            <FloatingLabel className='formInput' controlId="floatingInputGrid" label="Phone" >
                <Form.Control  className='inputSearch' value={storePhone}  type="text" placeholder="Phone" disabled />
            </FloatingLabel>
            <FloatingLabel className='formInput' controlId="floatingInputGrid" label="Location" >
                <Form.Control  className='inputSearch' value={location}  type="text" placeholder="Location" disabled />
            </FloatingLabel>
            <Button color="danger" style={{marginTop:'3%'}} onClick={detachStore}>{detachText}</Button>
        </div>
    </Modal>

    
    </div>
  )
}
